import React from 'react';
import Main from 'layouts/Main';
import { Container2 as Container } from 'components/Container';
import LogosSlider from '@/components/display/LogosSlider';
import FeaturesWithMobileScreenshot from '@/components/display/FeaturesWithMobileScreenshot';
import FullScreenHeroWithImageSlider from '@/components/display/FullScreenHeroWithImageSlider';
import CtaSimpleCentered from '@/components/display/CtaSimpleCentered';
import { Box } from '@mui/material';

const GlobalHRManagement = (): JSX.Element => {
  return (
    <Main colorInvert={false}>
      <Container id="FullScreenHeroWithImageSlider">
        <FullScreenHeroWithImageSlider
          title={'全球人力资源管理，数字化赋能跨国组织效能跃升'}
          subTitle={
            '当团队遍布六大洲，如何实现高效协同？我们的多语种服务团队，提供从跨境招聘、绩效管理到跨时区协作的全链路解决方案。通过自动化工作流和实时合规监控，让分散在全球的团队如同共处同一办公室般无缝协作'
          }
          buttonText={'立即咨询'}
          imageSrc="/images/products/hero/global-hr.png"
          imageAlt="全球人力资源管理"
          breadcrumbs={[
            {
              href: '/',
              title: '首页',
            },
            {
              title: '全球人力资源管理',
            },
          ]}
        />
      </Container>
      <Container id="LogoGridSimpleCentered" data-aos="fade-up">
        <LogosSlider title={'合作伙伴'} subTitle={'受到全球领先企业的信赖'} />
      </Container>
      <Container id="FeaturesWithMobileScreenshot" data-aos="fade-up">
        <FeaturesWithMobileScreenshot
          imageSrc="/images/products/global/hr-recruitment.png"
          imageAlt="全球人才招聘与配置"
          title="全球人才招聘与配置"
          subTitle="依托全球人才网络与专业招聘渠道，精准定位并吸引全球各地优秀人才，满足企业不同岗位与业务需求。同时，根据企业全球业务布局与岗位要求，合理配置人才，确保人岗匹配，发挥人才最大效能"
        />
      </Container>
      <Container id="FeaturesWithMobileScreenshot3" data-aos="fade-up">
        <FeaturesWithMobileScreenshot
          imagePosition="right"
          imageSrc="/images/products/global/hr-training.png"
          imageAlt="全球人才培训与发展"
          title="全球人才培训与发展"
          subTitle="结合不同国家和地区人才特点、企业文化以及业务发展需求，设计并实施个性化的培训与发展项目。从新员工入职培训到领导力提升课程，全方位助力员工成长，为企业培养具备全球视野和专业技能的人才队伍"
        />
      </Container>
      <Container id="FeaturesWithMobileScreenshot2" data-aos="fade-up">
        <FeaturesWithMobileScreenshot
          imageSrc="/images/products/global/hr-performance.png"
          imageAlt="全球绩效管理体系"
          title="全球绩效管理体系"
          subTitle="建立科学合理的全球绩效管理体系，兼顾不同地区文化差异和业务特点，制定公平、公正且具有激励性的绩效指标与评估标准。通过定期绩效评估与反馈，激励员工不断提升工作绩效，推动企业整体业绩增长"
        />
      </Container>
      <Container id="FeaturesWithMobileScreenshot2" data-aos="fade-up">
        <FeaturesWithMobileScreenshot
          imagePosition="right"
          imageSrc="/images/products/global/hr-relation.png"
          imageAlt="全球员工关系管理"
          title="全球员工关系管理"
          subTitle="关注全球员工的多元化需求，建立良好的员工沟通与反馈机制，妥善处理劳动纠纷与员工关系问题。举办各类员工关怀活动，增强员工归属感与忠诚度，营造和谐稳定的全球工作氛围"
        />
      </Container>
      <Box sx={{ background: '#F8FAFC' }}>
        <Container id="CtaSimpleCentered" data-aos="fade-up">
          <CtaSimpleCentered subTitle="智能化全球人才数据的高效管理与分析，简化繁琐流程提升管理效率" />
        </Container>
      </Box>
    </Main>
  );
};

export default GlobalHRManagement;
